export default __webpack_public_path__ + "static/media/icon_user-male.e09bdbba.svg";